import axios from "axios";
import store from "@/store";

const METHODS = {
    GET: 'get',
    POST: 'post',
    PUT: 'put',
    PATCH: 'patch',
    DELETE: 'delete',
}

/**
 * @param { Record<string,any> | undefined | null} data {a: 1, b: 2, c: {d: 123}, k: [1, 2, 3]}
* */
function queryStringify(data) {
    if (!data) return '';
    const arr = Object.entries(data);
    const length = arr.length;
    if (!length)
        return '';
    return arr.reduce((res, el, index) => {
        return `${res}${el[0]}=${el[1]}${index !== (length - 1) ? '&' : ''}`
    }, '?');
}
export function debounce(func, wait = 1000) {
    let timeout;
    return Promise.resolve(function(...args) {
        const context = this;
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
            timeout = null;
            func.apply(context, args);
        }, wait);
    })
}

export class Transport {
    endpoint = '';
    controller = new AbortController();
    get year(){
        if (store)
            return store.getters['keycloak/currentApiYear']
        return null
    }
    get finallyEndpoint(){
        return `/api${this.year ? `/${this.year}` : ''}${this.endpoint}`
    }
    constructor(endpoint) {
        this.endpoint = endpoint;// /api${this.year ? `/${this.year}` : ''}
    }
    /**
     * @param {string} path
     * @param { {headers?: Record<string, any>,withoutToken?: boolean, data?: Record<string, any>} } [options]
     * */
    get(path, options) {
        return this._request(this.finallyEndpoint + path, {
            ...options,
            method: METHODS.GET
        });
    }
    abort(){
        this.controller.abort();
    }
    /**
     * @param {string} path
     * @param { {headers?: Record<string, any>,withoutToken?: boolean, data?: Record<string, any>} } options
     * */
    post(path, options) {

        return this._request(this.finallyEndpoint + path, {
            ...options,
            method: METHODS.POST
        });
    }
    /**
     * @param {string} path
     * @param { {headers?: Record<string, any>,withoutToken?: boolean, data?: Record<string, any>} } [options]
     * */
    put(path, options) {
        return this._request(this.finallyEndpoint + path, {
            ...options,
            method: METHODS.PUT
        });
    }
    /**
     * @param {string} path
     * @param { {headers?: Record<string, any>,withoutToken?: boolean, data?: Record<string, any>} } [options]
     * */
    delete(path, options) {

        return this._request(this.finallyEndpoint + path, {
            ...options,
            method: METHODS.DELETE
        });
    }
    /**
     * @param {string} url
     * @param { {headers?: Record<string, any>,withoutToken?: boolean, data?: Record<string, any>, method: keyof typeof METHODS | Lowercase<keyof typeof METHODS>} } options
     * */
    _request(url, options){
        const headers = Object.entries(options?.headers ?? {}).reduce((acc,[key,value]) => {
            acc[key] = value;
            return acc;
        }, {});
        if (!options.withoutToken)
            headers['Authorization'] =  `Bearer   ${ store.getters['keycloak/getKeycloakData']?.token}`;
        //need to get access to abort from output
        headers.signal = this.controller.signal;
        const config = {
            headers,
            responseType: options?.responseType
        }
        if (['get', 'delete'].includes(options.method))
            return axios[options.method](url + queryStringify(options.data), config)
        else
            return axios[options.method](url,options.data, config)
    }
}